import React from 'react'

const Instagram = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="31"
      height="31"
      viewBox="0 0 31 31"
    >
      <g>
        <g>
          <g>
            <path
              className="outer-path"
              fill="#939393"
              d="M15.5 31C24.06 31 31 24.06 31 15.5 31 6.94 24.06 0 15.5 0 6.94 0 0 6.94 0 15.5 0 24.06 6.94 31 15.5 31z"
            />
          </g>
          <g>
            <g>
              <path
                fill="#fff"
                d="M15.339 12.205c4.58 0 4.586 6.924 0 6.924zm0-1.87a5.33 5.33 0 0 0-5.335 5.327 5.33 5.33 0 0 0 5.335 5.325 5.329 5.329 0 0 0 5.333-5.325 5.33 5.33 0 0 0-5.333-5.327zm4.29-.205a1.25 1.25 0 1 0 2.5-.001 1.25 1.25 0 0 0-2.5 0zm-5.221-2.97c8.877-.015 10.006-1.001 9.383 12.697-.222 4.845-3.913 4.313-8.451 4.313-8.274 0-8.512-.237-8.512-8.508 0-8.367.656-8.498 7.58-8.505zM5.5 8.87c-.638 1.634-.545 3.757-.545 6.797 0 2.667-.086 5.174.545 6.796 1.54 3.96 5.613 3.58 9.836 3.58 4.075 0 8.276.425 9.838-3.58.639-1.651.545-3.742.545-6.796 0-4.054.224-6.671-1.744-8.636-1.992-1.99-4.685-1.741-8.639-1.741-4.254 0-8.293-.378-9.836 3.58z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Instagram
